import {
    CREATE_GRAFFITI_LOADING,
    CREATE_GRAFFITI_SUCCESS,
    CREATE_GRAFFITI_FAILURE,

    CREATE_DRAWING_LOADING,
    CREATE_DRAWING_SUCCESS,
    CREATE_DRAWING_FAILURE,
} from '../actionTypes'
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';
import { colyClient } from '../../services/Panel-initialisation.service';
import LZString from 'lz-string'

export const createGraffitiSuccess = payload => ({
    type: CREATE_GRAFFITI_SUCCESS,
    payload
})

export const createGraffitiFailure = () => ({
    type: CREATE_GRAFFITI_FAILURE
})

export const createGraffitiAsync = payload => dispatch => {
    const { _id, text, surfaceService, surfaceId, item, character } = payload;

    if (surfaceService === 'writing-surface-instances') {
        colyClient.room.send('doAction', {
            serviceName: surfaceService,
            commandType: 'patch',
            data: {
                _id: surfaceId,
                graffiti: LZString.compressToUTF16(JSON.stringify(text)),
                pixelsArray: LZString.compressToUTF16(JSON.stringify([]))
            }
        })
    } else {
        colyClient.room.send('doSuperAction', {
            name: 'gather',
            data: {
                resources: surfaceService,
                characterId: character?._id, // , // if gathering for yourself, use this
                panelId: character?.panelId,
                panelAreas: surfaceId,
                z: character.z,
                graffiti: LZString.compressToUTF16(JSON.stringify(text)),
                pixelsArray: LZString.compressToUTF16(JSON.stringify([]))
            },
        })
    }


    

    return new Promise((resolve, reject) => (resolve()))
}

export const createDrawingSuccess = payload => ({
    type: CREATE_DRAWING_SUCCESS,
    payload
})

export const createDrawingFailure = () => ({
    type: CREATE_DRAWING_FAILURE
})

export const createDrawingAsync = payload => dispatch => {
    const { _id, dataUrl, surfaceService, surfaceId, pixelsArray, item, character } = payload;

    console.log('createGraffitiAsync', {
        resources: surfaceService,
        characterId: character?._id, // , // if gathering for yourself, use this
        panelId: character?.panelId,
        panelAreas: surfaceId,
        z: character.z,
        graffiti: '',
        pixelsArray
    });

    if (surfaceService === 'writing-surface-instances') {
        console.log({
            serviceName: surfaceService,
            commandType: 'patch',
            data: {
                _id: surfaceId,
                graffiti: '',
                pixelsArray: LZString.compressToUTF16(JSON.stringify(pixelsArray))
            }
        })
        colyClient.room.send('doAction', {
            serviceName: surfaceService,
            commandType: 'patch',
            data: {
                _id: surfaceId,
                graffiti: '',
                pixelsArray: LZString.compressToUTF16(JSON.stringify(pixelsArray))
            }
        })
    } else {
        colyClient.room.send('doSuperAction', {
            name: 'gather',
            data: {
                resources: surfaceService,
                characterId: character?._id, // , // if gathering for yourself, use this
                panelId: character?.panelId,
                panelAreas: surfaceId,
                z: character.z,
                graffiti: '',
                pixelsArray: LZString.compressToUTF16(JSON.stringify(pixelsArray))

            },
        })
    }

    return new Promise((resolve, reject) => (resolve()))
}

export const createNewGraffitiItemAsync = payload => dispatch => {
    const { _id, text, surfaceService, item, selectedCharacterId, workshopId, userId } = payload;

    console.log('workshopId!!!', workshopId)

    const fieldsToDelete = [
        'type',
    ]

    fieldsToDelete.forEach(field => {
        delete item[field];
    })

    colyClient.room.send('doSuperAction', {
        serviceName: surfaceService,
        name: 'create',
        data: {
            ...item,
            graffiti: LZString.compressToUTF16(JSON.stringify(text)),
            pixelsArray: LZString.compressToUTF16(JSON.stringify([])),
            selectedCharacterId,
            workshopId
        }
    })

    return new Promise((resolve, reject) => (resolve()))
}

export const createNewDrawingItemAsync = payload => dispatch => {
    const { _id, surfaceService, pixelsArray, item } = payload;

    const fieldsToDelete = [
        'type',
    ]

    fieldsToDelete.forEach(field => {
        delete item[field];
    })

    colyClient.room.send('doAction', {
        serviceName: surfaceService,
        commandType: 'create',
        data: {
            ...item,
            graffiti: '',
            pixelsArray: LZString.compressToUTF16(JSON.stringify(pixelsArray))
        }
    })

    return new Promise((resolve, reject) => (resolve()))
}
